import React from 'react';
import AppContainer from "./redux/containers/AppContainer";
import { applyMiddleware, compose, createStore } from "redux";
import reducer from "./redux/reducers";
import { enableMapSet } from "immer";
import { stateToJSON } from './stateToJSON';
import { importAppState } from './redux/actions';
import './static/css/all.iso.css';
import './static/css/bootstrap.iso.css';
import './static/css/index.iso.css';
import './static/css/google-fonts.css';
import { LogicContext } from './logicContext';
import { IMPORT_APP, SYNC_MATH_STATE, SET_CONSTANTS, SET_PREDICATES, SET_FUNCTIONS, CHECK_SYNTAX } from './redux/actions/action_types';
enableMapSet();

function filterAction(action) {
  switch (action.type) {
    case IMPORT_APP:
    case SYNC_MATH_STATE:
      return true;

    case SET_CONSTANTS:
    case SET_PREDICATES:
    case SET_FUNCTIONS:
    case CHECK_SYNTAX:
      if (action.ignore === true) {
        return true;
      }

      return false;

    default:
      return false;
  }
}

function prepare(initialState) {
  const composeEnhancers = typeof window === 'object' && // @ts-ignore
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? // @ts-ignore
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    name: 'structure-explorer'
  }) : compose;

  const stateMonitor = store => next => action => {
    console.log('structure explorer redux action:', action);

    if (instance.handleStoreChange && !filterAction(action)) {
      instance.handleStoreChange();
    }

    return next(action);
  };

  const enhancer = composeEnhancers(applyMiddleware(stateMonitor));
  const instance = {
    // @ts-ignore
    store: createStore(reducer, enhancer),
    handleStoreChange: undefined
  };

  const getState = instance => stateToJSON(instance.store.getState());

  if (initialState !== null) {
    instance.store.dispatch(importAppState(initialState, instance.store.getState().diagramState));
  } //instance.store.subscribe(() => instance.handleStoreChange && instance.handleStoreChange())


  return {
    instance,
    getState
  };
}

function AppComponent({
  instance,
  onStateChange,
  isEdited,
  context
}) {
  const store = instance.store;
  instance.handleStoreChange = onStateChange;
  return /*#__PURE__*/React.createElement("div", {
    className: "fol-graphexplorer-cYTZ7LnVXZ"
  }, /*#__PURE__*/React.createElement("div", {
    className: `container-fluid${!isEdited ? ' view-mode' : ''}`
  }, /*#__PURE__*/React.createElement(LogicContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(AppContainer, {
    store: store
  }))));
}

export default {
  prepare,
  AppComponent
};